// extracted by mini-css-extract-plugin
module.exports = {"container":"_1oy5o8WIeh7xEGf5klJ-In","header":"_1ad_3zcnCZJsA08vCsSm38","label":"_3Bu-Sn-bSIb3fqggbmh6Ip","content":"_2ZYu3EJ1x23WWruvKT1wZz"};